export const AUTH_TYPE = { none: 0, basic: 1, apiKey: 2, oauth2: 3, basicTimeBased: 4 } as const
export type AuthType = typeof AUTH_TYPE[keyof typeof AUTH_TYPE]

export const RESTOCK_PULL_TYPE = { onDemand: 0, minMax: 1, originalPack: 2 } as const
export type RestockPullType = typeof RESTOCK_PULL_TYPE[keyof typeof RESTOCK_PULL_TYPE]

// export const ORDER_HEAD_STATUS = { pending: 'pending', inProgress: 'inProgress', completed: 'completed' } as const
export const ORDER_HEAD_STATUS = { pending: 0, inProgress: 1, completed: 2, cancelled: 3 } as const
export type OrderHeadStatus = typeof ORDER_HEAD_STATUS[keyof typeof ORDER_HEAD_STATUS]

// export const DELIVERY_HEAD_STATUS = { pending: 'pending', inProgress: 'inProgress', completed: 'completed', cancelled: 'cancelled' } as const
export const DELIVERY_HEAD_STATUS = { pending: 0, inProgress: 1, completed: 2, cancelled: 3 } as const
export type DeliveryHeadStatus = typeof DELIVERY_HEAD_STATUS[keyof typeof DELIVERY_HEAD_STATUS]

export const CONSUMPTION_HEAD_STATUS = { pending: 0, inProgress: 1, completed: 2, cancelled: 3 } as const
export type ConsumptionHeadStatus = typeof CONSUMPTION_HEAD_STATUS[keyof typeof CONSUMPTION_HEAD_STATUS]

export const CONSUMPTION_HEAD_EXPORT_STATUS = { none: 0, inProgress: 1, successful: 2, failed: 3, cancelled: 4 } as const
export type ConsumptionHeadExportStatus = typeof CONSUMPTION_HEAD_EXPORT_STATUS[keyof typeof CONSUMPTION_HEAD_EXPORT_STATUS]

export const CONSUMPTION_LINE_EXPORT_STATUS = { none: 0, inProgress: 1, successful: 2, failed: 3, cancelled: 4 } as const
export type ConsumptionLineExportStatus = typeof CONSUMPTION_LINE_EXPORT_STATUS[keyof typeof CONSUMPTION_LINE_EXPORT_STATUS]
